import { SHELL } from "../../shell/shell.const";

const AVAILABLE_PROJECTS = 'invertir' ;
const AVAILABLE_PROJECTS_HOME = '' ;

export const AVAILABLE_PROJECTS_ROUTES = {
    AVAILABLE_PROJECTS,

    AVAILABLE_PROJECTS_HOME,

    ROUTE_AVAILABLE_PROJECTS_HOME: `${SHELL}/${AVAILABLE_PROJECTS}/${AVAILABLE_PROJECTS_HOME}`,
}

